import { theme } from "antd";
import type { CSSProperties } from "react";

export const inputStyle = (token: ReturnType<typeof theme.useToken>["token"]): CSSProperties => ({
  borderRadius: token.borderRadiusLG,
  background: token.colorBgContainer,
  border: `1px solid ${token.colorBorderSecondary}`,
  fontSize: 14,
  fontWeight: 500,
});
